import Share from "react-native-share";
import RNFetchBlob from "react-native-blob-util";
import { Linking, Alert } from "react-native";

// returns phonenumber in the format like 919999999999
const formatPhoneNumber = (phoneNumber) => {
  if (typeof phoneNumber === "string") {
    switch (phoneNumber.length) {
      case 10:
        return `91${phoneNumber}`;
      case 12:
        return phoneNumber;
      case 13:
        return phoneNumber.slice(1);
    }
  }
  return "";
};

export const WhatsappContentType = {
  text: "TEXT",
  singleImg: "IMAGE",
  multiImg: "IMAGES",
};

export const InvokeType = {
  both: "BOTH",
  whatsappBiz: "WHATSAPP_BIZ",
  whatsapp: "WHATSAPP",
  none: "PLEASE_INSTALL",
};

export const shareOnWhatsapp = async ({
  message,
  image,
  images = [],
  phoneNumber,
  invoke,
}) => {
  let type = WhatsappContentType.text;
  if (typeof image === "string" && image) type = WhatsappContentType.singleImg;
  if (images && Array.isArray(images) && images.length)
    type = WhatsappContentType.multiImg;

  const { isInstalled: haveWhatsAppBusiness } =
    await Share.isPackageInstalled("com.whatsapp.w4b");

  const { isInstalled: haveWhatsApp } =
    await Share.isPackageInstalled("com.whatsapp");
  let invokeType = InvokeType.whatsapp;
  if (invoke) {
    invokeType = invoke;
  } else {
    if (!haveWhatsApp && !haveWhatsAppBusiness) invokeType = InvokeType.none;
    if (!haveWhatsApp && haveWhatsAppBusiness) invokeType = InvokeType.both; // TODO: fix image sharing in WA business, use type whatsappBiz
    if (haveWhatsApp && !haveWhatsAppBusiness) invokeType = InvokeType.whatsapp;
    if (haveWhatsApp && haveWhatsAppBusiness) invokeType = InvokeType.both;
  }

  if (invokeType === InvokeType.none) {
    Alert.alert(
      "Whatsapp",
      "शेयर करने के लिए व्हाट्सप्प इनस्टॉल करें",
      [
        {
          text: "Ok",
          onClose: () => {},
        },
      ],
      { cancelable: true },
    );
    return;
  }

  if (invokeType === InvokeType.both) {
    shareOnWhatsAppOrBiz(message, image);
    return;
  }

  if (invokeType === InvokeType.whatsapp && type === WhatsappContentType.text) {
    shareTextonWhatsApp(message, phoneNumber);
    return;
  }

  if (
    invokeType === InvokeType.whatsapp &&
    type === WhatsappContentType.singleImg
  ) {
    shareEntityOnWhatsApp(message, image, phoneNumber);
    return;
  }

  if (invoke === InvokeType.whatsappBiz && type === WhatsappContentType.text) {
    shareTextonWhatsApp(message, phoneNumber);
    return;
  }

  if (
    invoke === InvokeType.whatsappBiz &&
    type === WhatsappContentType.singleImg
  ) {
    // shareEntityWhatsAppBusiness(message, image, phoneNumber); return;
    shareTextonWhatsApp(message);
    return;
  }

  if (
    type === WhatsappContentType.multiImg &&
    (haveWhatsAppBusiness || haveWhatsApp)
  ) {
    shareEntitiesOnWhatsApp(message, images);
  }
};

export const shareTextonWhatsApp = async (message = "", phone) => {
  let url = `whatsapp://send?text=${message}`;

  if (phone) {
    url += `&phone=+91${phone}`;
  }

  try {
    await Linking.openURL(url);
  } catch (e) {
    console.log(e);
  }
};

export const shareEntityOnWhatsApp = async (
  message = "",
  image = "",
  phoneNumber,
) => {
  try {
    const response = await fetch(image);

    const blob = await response.blob();

    const reader = new FileReader();
    reader.readAsDataURL(blob);

    reader.onloadend = async function () {
      const base64data = reader.result;
      const convert = base64data.replace(
        "data:application/octet-stream;",
        "data:image/png;",
      );

      const shareOptions = {
        title: "Share via",
        message,
        url: convert,
        social: Share.Social.WHATSAPP,
        failOnCancel: false,
        filename: "test",
        whatsAppNumber: formatPhoneNumber(phoneNumber),
      };
      await Share.shareSingle(shareOptions);
    };
  } catch (e) {
    console.log(e);
  }
};

export const shareEntityWhatsAppBusiness = async (
  message = "",
  image = "",
  phoneNumber,
) => {
  try {
    const response = await fetch(image);

    const blob = await response.blob();

    const reader = new FileReader();
    reader.readAsDataURL(blob);

    reader.onloadend = async function () {
      const base64data = reader.result;
      const convert = base64data.replace(
        "data:application/octet-stream;",
        "data:image/png;",
      );

      const shareOptions = {
        title: "Share via",
        message,
        url: convert,
        social: "whatsappbusiness",
        failOnCancel: false,
        filename: "test",
        whatsAppNumber: formatPhoneNumber(phoneNumber),
      };
      await Share.shareSingle(shareOptions);
    };
  } catch (e) {
    console.log(e);
  }
};

export const shareEntitiesOnWhatsApp = async (message = "", images = []) => {
  const Images = images.map((img) =>
    RNFetchBlob.config({
      fileCache: true,
    })
      .fetch("GET", img)
      .then((resp) => {
        const base64s = RNFetchBlob.fs
          .readFile(resp.data, "base64")
          .then((data) => `data:image/jpeg;base64,${data}`);
        return base64s;
      }),
  );

  Promise.all(Images).then((urls) => {
    const options = {
      title: "Share via",
      message,
      urls,
      social: Share.Social.WHATSAPP,
      failOnCancel: false,
      filename: "test",
    };
    Share.shareSingle(options);
  });
};

export const shareOnWhatsAppOrBiz = async (message, image) => {
  const { isInstalled: haveWhatsAppBusiness } =
    await Share.isPackageInstalled("com.whatsapp.w4b");

  const { isInstalled: haveWhatsApp } =
    await Share.isPackageInstalled("com.whatsapp");

  if (haveWhatsAppBusiness && haveWhatsApp) {
    Alert.alert(
      "Whatsapp",
      "आप किस ऍप पर शेयर करना चाहते हैं",
      [
        {
          text: "Whatsapp",
          onPress: () => shareEntityOnWhatsApp(message, image),
        },
        {
          text: "Whatsapp Business",
          onPress: () => shareTextonWhatsApp(message),
        },
      ],
      { cancelable: false },
    );
  } else if (!haveWhatsApp && haveWhatsAppBusiness) {
    shareTextonWhatsApp(message);
  } else if (haveWhatsApp && !haveWhatsAppBusiness) {
    shareEntityOnWhatsApp(message, image);
  } else {
    Alert.alert(
      "Whatsapp",
      "शेयर करने के लिए व्हाट्सप्प इनस्टॉल करें",
      [
        {
          text: "Ok",
          onClose: () => {},
        },
      ],
      { cancelable: true },
    );
  }
};
